import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { UnitsSettingsComponent } from './units-settings.component'

export const unitsRoutes: Routes = [
  {
    path: 'admin/settings/units_settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: UnitsSettingsComponent,
        data: {
          permissions: {
            only: 'SYSTEM_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
